[
    {
        "id":1,      
        "name": "BEBE GESTANTE",
        "acronym": "BG"
    },
    {
        "id":2,
        "name": "CEDULA DE CIUDADANÍA ",
        "acronym": "CC"
    },
    {
        "id":3,
        "name": "CEDULA DE EXTRANJERÍA",
        "acronym": "CE"
    },
    {
        "id":4,
        "name": "NACIDO VIVO",
        "acronym": "CN"
    },
    {
        "id":5,
        "name": "PASAPORTE",
        "acronym": "PA"
    },
    {
        "id":6,
        "name": "PERMISO ESPECIAL DE PERMANENCIA",
        "acronym": "PE"
    },
    {
        "id":7,
        "name": "PERMISO POR PROTECCIÓN TEMPORAL",
        "acronym": "PT"
    },
    {
        "id":8,
        "name": "REGISTRO CIVIL DE NACIMIENTO",
        "acronym": "RC"
    },
    {
        "id":9,
        "name": "TARJETA DE IDENTIDAD",
        "acronym": "TI"
    }
]